// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a600817d","455":"2e7c9ad1","977":"dbbbb2d2"}[chunkId] + ".chunk.js";
};